import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconAlignJustifyComponent } from "./med-icon-align-justify.component";

@NgModule({
  declarations: [
    MedIconAlignJustifyComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconAlignJustifyComponent,
  ],
})
export class MedIconAlignJustifyModule { }
